import { Flex } from '@banhala/ui-kit';
import type { IconListProps } from './types';
import { FixedColumnIconList } from './FixedColumnIconList';
import { isNil } from '../../../../utils';

export const FourColIconList = ({ entity }: IconListProps) => {
  if (isNil(entity) || entity.length === 0) {
    return null;
  }

  return (
    <Flex.Column padding={{ top: 24, horizontal: 24 }} gap={24}>
      <FixedColumnIconList
        entity={entity}
        column={4}
        iconSize="small"
        analyticsEventName="CLICK_FOUR_COL_ICON_LIST"
        componentType={'FOUR_COL_ICON_LIST'}
      />
    </Flex.Column>
  );
};
